import axios from 'axios';

const deleteStaff = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_API_URL}/api/staff/${id}`)
    .then(res => res)
    .catch(err => err);
};

export default deleteStaff;
